import {inject, Injectable} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map, Observable, shareReplay} from 'rxjs';

/**
 * Single source of truth for layout breakpoints.
 *
 * Matches the Bootstrap 5.3 scale already loaded globally, so SCSS media queries
 * and TS checks agree. Use this instead of window.innerWidth — that goes stale on
 * rotate/resize because nothing re-reads it.
 */
@Injectable({providedIn: 'root'})
export class ResponsiveService {
  private breakpointObserver = inject(BreakpointObserver);

  /** < 768px — phones. Tables render as stacked cards, sidebar is an off-canvas drawer. */
  readonly isPhone$ = this.observe('(max-width: 767.98px)');

  /** < 992px — phones + portrait tablets. Sidebar is an off-canvas drawer. */
  readonly isDrawerLayout$ = this.observe('(max-width: 991.98px)');

  /** < 1024px — the POS/place-order "tablet view" that opens the cart as a dialog. */
  readonly isTablet$ = this.observe('(max-width: 1023.98px)');

  private observe(query: string): Observable<boolean> {
    return this.breakpointObserver.observe([query]).pipe(
      map(result => result.matches),
      shareReplay({bufferSize: 1, refCount: false})
    );
  }
}
